import {
  PublicClientApplication,
  AuthenticationResult,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
import { msalConfig } from "@configurations/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

export default msalInstance;
